var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"objective-option",class:_vm.objective === _vm.icon ? 'active-objective' : '',on:{"click":_vm.selectObjective}},[_c('div',[_c('div',[_c('Icon',{attrs:{"name":_vm.icon}})],1),_c('div',[_c('h4',[_vm._v(_vm._s(_vm.title))]),_c('p',[_vm._v(_vm._s(_vm.description))])])])])
}
var staticRenderFns = []

export { render, staticRenderFns }